// @flow

import { getPolopolyImageElement, getImageElement } from '../utils/imageUtils'
import { getOverlayElement } from '../utils/renderUtils'

import { alignCenter, alignMiddle } from '../stylesheets/alignment/index.css'
import { background, uncroppedImageContainer } from '../stylesheets/background.css'

type propTypes = {
  backgroundImage: ?string,
  polopolyId: ?string,
  uncropped: ?Boolean,
  overlay: ?Object | ?Boolean,
  alignment: ?Array<string>
}

export const imageComponent = {
  type: 'image',
  render(id: string, props: propTypes, bgInnerHTML: ?string = ''): string {
    const { backgroundImage, polopolyId, uncropped = false, overlay, alignment } = props

    const alignmentClasses = alignment ?
      alignment.join(' ') :
      [alignMiddle, alignCenter].join(' ')

    const imageStyle = uncropped ?
      'position: relative' :
      'min-width: 100%; min-height: 100%; position: relative;'

    let imageElement = ''
    if (polopolyId) {
      imageElement = getPolopolyImageElement(polopolyId, alignmentClasses, imageStyle)
    } else if (backgroundImage) {
      imageElement = getImageElement(backgroundImage, alignmentClasses, imageStyle)
    }

    return `
      <div id="${id}" class="${background}">
        ${uncropped ? `<div class="${uncroppedImageContainer}">` : ''}
          ${imageElement}
        ${uncropped ? '</div>' : ''}
        ${getOverlayElement(overlay)}
        ${bgInnerHTML}
      </div>
    `
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/image.js